'use client';

import React from 'react';
import Image from 'next/image';
import MapPinIcon from '../../icons/MapPinIcon';
import { Button } from '../../components/ui/Button';

export default function Localizacao() {
  return (
    <div className="min-h-screen flex flex-col items-center bg-[#FFFBF5]">
      <div className="flex flex-col items-center gap-4 mb-2 sm:mb-0 bg-[#192437] w-full p-8">
        <a href="/">
          <Image
            src="/logo-jb-primary.svg"
            alt="Escritório de advocacia John Bihuna em Biguaçu, SC"
            width={228}
            height={72}
            className="w-[228px] h-[72px]"
          />
        </a>
      </div>
      <div className="p-4 sm:p-8 sm:mt-10 w-full max-w-4xl flex flex-col gap-2">
        <h1 className="text-secondary text-2xl sm:text-4xl font-bold mb-4">
          Escritório de Advocacia em Biguaçu - SC
        </h1>
        <p className="text-primary text-base font-medium mt-2 mb-4">
          <strong>Localização estratégica em Biguaçu</strong>
        </p>
        <p className="text-primary text-sm font-medium mb-3">
          Nosso escritório de advocacia está localizado na <strong>R. Maj. Livramento, 654 - Loja 3, Jardim Universitário, Biguaçu/SC</strong>, com fácil acesso para toda a Grande Florianópolis.
        </p>
        <p className="text-primary text-sm font-medium mb-3">
          <strong>Atendemos clientes em toda Santa Catarina e demais estados do Brasil.</strong>
        </p>
        <p className="text-primary text-sm font-medium">
          Oferecemos um ambiente acolhedor e moderno, onde você receberá atendimento personalizado do nosso escritório. Aqui, construímos soluções jurídicas eficientes em Direito Cível, Família, Imobiliário e Tributário, atendendo presencialmente em nosso escritório ou remotamente para clientes de todo o país.
        </p>
        <div className="mt-6 w-full rounded-xl overflow-hidden shadow-sm">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3535.9!2d-48.660654!3d-27.4978736!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjfCsDI5JzUyLjQiUyA0OMKwMzknMzguNCJX!5e0!3m2!1spt-BR!2sbr!4v1"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Localização do escritório de advocacia John Bihuna em Biguaçu SC"
          />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-6 sm:mt-6 w-full sm:w-auto justify-center p-3">
        <Button
          component="a"
          href="https://www.google.com/maps?gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIGCAEQRRg8MhUIAhAuGCcYrwEYxwEYgAQYigUYjgUyBggDECMYJzIKCAQQABgKGBYYHjIKCAUQABiABBiiBDIGCAYQRRg8MgYIBxBFGDzSAQgxNTI0ajBqNKgCALACAQ&um=1&ie=UTF-8&fb=1&gl=br&sa=X&geocode=KdlztFsATSeVMf2Tmbo44iGr&daddr=R.+Maj.+Livramento,+654+-+Loja+3+-+Jardim+Universit%C3%A1rio,+Bigua%C3%A7u+-+SC,+88161-036"
          target="_blank"
          variant="default"
          icon={<MapPinIcon className="fill-[#C09957]" />}
          className="flex justify-center"
        >
          LOCALIZAÇÃO DO ESCRITÓRIO
        </Button>
      </div>
    </div>
  );
}
